<ng-ut-empty-permit
  *ngIf="(store$ | async) as store"
  [permit]="permitDetail"
  [loading]="store.permit.loadingPermit || false"
  (refresh)="getPermit()"
></ng-ut-empty-permit>
